/* TOKIYO LIFESTYLE — product-page.js */
'use strict';

/* ---- Variant picker ---- */
function initVariantPicker() {
  const picker = document.querySelector('[data-variant-picker]');
  if (!picker) return;

  const variantData = JSON.parse(document.querySelector('[data-variant-json]')?.textContent || '[]');
  const addBtn      = document.querySelector('[data-add-to-cart-btn]');
  const priceEl     = document.querySelector('[data-product-price]');
  const compareEl   = document.querySelector('[data-product-compare-price]');
  const stockEl     = document.querySelector('[data-stock-indicator]');
  const variantIdInput = document.querySelector('[name="id"]');

  function getCurrentVariant() {
    const selected = {};
    picker.querySelectorAll('[data-option-name]').forEach(input => {
      if (input.checked || input.tagName === 'SELECT') {
        const pos = parseInt(input.getAttribute('data-option-position') || '1', 10) - 1;
        selected[pos] = input.value;
      }
    });
    return variantData.find(v =>
      v.options.every((opt, i) => {
        return selected[i] === opt;
      })
    );
  }

  function updateAvailability() {
    const selected = {};
    picker.querySelectorAll('[data-option-name]').forEach(input => {
      if (input.checked || input.tagName === 'SELECT') {
        const pos = parseInt(input.getAttribute('data-option-position') || '1', 10) - 1;
        selected[pos] = input.value;
      }
    });

    const optionInputs = picker.querySelectorAll('[data-option-name]');
    optionInputs.forEach(input => {
      const pos = parseInt(input.getAttribute('data-option-position') || '1', 10) - 1;
      const testSelected = Object.assign({}, selected, { [pos]: input.value });
      
      const match = variantData.find(v =>
        v.options.every((opt, i) => {
          return testSelected[i] === opt;
        })
      );
      
      const wrapper = input.closest('.size-button, .color-swatch');
      if (wrapper) {
        wrapper.classList.toggle('is-unavailable', !match || !match.available);
      }
    });
  }

  function updateUI(variant) {
    if (!variant) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
      return;
    }
    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      compareEl.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
      compareEl.hidden = !(variant.compare_at_price > variant.price);
    }
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? (addBtn.dataset.addText || 'Add to Cart') : 'Sold Out';
    }
    const buyNowBtn = document.querySelector('.product-info__buy-now');
    if (buyNowBtn) {
      buyNowBtn.disabled = !variant.available;
      if (variant.available) {
        buyNowBtn.style.setProperty('display', 'block', 'important');
      } else {
        buyNowBtn.style.setProperty('display', 'none', 'important');
      }
    }
    // buyNowBtn display updated directly based on availability
    if (stockEl) {
      const qty = variant.inventory_quantity;
      const managed = variant.inventory_management === 'shopify';
      if (managed && qty <= 5 && qty > 0) {
        stockEl.textContent = `Only ${qty} left in stock`;
        stockEl.className = 'stock-indicator stock-indicator--low';
      } else if (managed && qty <= 0) {
        stockEl.textContent = 'Out of Stock';
        stockEl.className = 'stock-indicator stock-indicator--out';
      } else {
        stockEl.textContent = 'In Stock';
        stockEl.className = 'stock-indicator stock-indicator--in';
      }
    }

    // Update the color name text under the label and filter the gallery:
    const selectedColorInput = picker.querySelector('input[data-option-name="Color"]:checked, input[name="Color"]:checked');
    let colorVal = null;
    if (selectedColorInput) {
      colorVal = selectedColorInput.value;
      document.querySelectorAll('[data-selected-color-name]').forEach(el => {
        el.textContent = colorVal;
      });
    } else {
      const checkColorInput = picker.querySelector('[data-option-name="Color"]');
      if (checkColorInput) {
        const pos = parseInt(checkColorInput.getAttribute('data-option-position') || '1', 10) - 1;
        colorVal = variant.options[pos];
      }
    }

    if (colorVal) {
      filterGalleryByColor(colorVal, variant);
    }

    /* Update URL without reload */
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url);

    updateAvailability();
  }

  picker.addEventListener('change', () => {
    const variant = getCurrentVariant();
    updateUI(variant);
  });

  /* Init with current variant */
  const urlVariant = new URLSearchParams(window.location.search).get('variant');
  const domVariant = getCurrentVariant();
  const initial = urlVariant ? variantData.find(v => String(v.id) === urlVariant) : (domVariant || variantData.find(v => v.available) || variantData[0]);
  if (initial) updateUI(initial);
  updateAvailability();
}

/* ---- Filter Gallery by Color ---- */
function filterGalleryByColor(selectedColor, variant) {
  const track = document.querySelector('[data-gallery-track]');
  const thumbs = document.querySelector('[data-gallery-thumbs]');
  if (!track) return;

  const slides = [...track.querySelectorAll('.product-gallery__slide')];
  const allThumbs = thumbs ? [...thumbs.querySelectorAll('[data-thumb]')] : [];

  const cleanColor = selectedColor ? selectedColor.toLowerCase().trim() : '';

  // Filter slides
  slides.forEach(slide => {
    const imgColor = slide.getAttribute('data-color') ? slide.getAttribute('data-color').toLowerCase().trim() : '';
    const isSizeGuide = slide.getAttribute('data-media-id') === 'size-guide-slide';
    if (!cleanColor || isSizeGuide || !imgColor || imgColor === cleanColor) {
      slide.classList.remove('is-hidden');
      slide.style.display = '';
    } else {
      slide.classList.add('is-hidden');
      slide.style.display = 'none';
    }
  });

  // Filter thumbs
  allThumbs.forEach(thumb => {
    const imgColor = thumb.getAttribute('data-color') ? thumb.getAttribute('data-color').toLowerCase().trim() : '';
    const isSizeGuide = thumb.getAttribute('data-media-id') === 'size-guide-slide';
    if (!cleanColor || isSizeGuide || !imgColor || imgColor === cleanColor) {
      thumb.classList.remove('is-hidden');
      thumb.style.display = '';
    } else {
      thumb.classList.add('is-hidden');
      thumb.style.display = 'none';
    }
  });

  // Select target thumbnail (variant featured media or first visible product image)
  const visibleThumbs = allThumbs.filter(t => !t.classList.contains('is-hidden'));
  if (visibleThumbs.length > 0) {
    let targetThumb = null;
    if (variant && (variant.featured_media || variant.featured_image)) {
      const mediaId = String(variant.featured_media?.id || variant.featured_image?.id);
      targetThumb = visibleThumbs.find(t => t.getAttribute('data-media-id') === mediaId);
    }
    if (!targetThumb) {
      targetThumb = visibleThumbs.find(t => t.getAttribute('data-media-id') !== 'size-guide-slide') || visibleThumbs[0];
    }
    if (targetThumb) {
      targetThumb.click();
    }
  }
}

/* ---- Image gallery ---- */
function initGallery() {
  const gallery    = document.querySelector('[data-product-gallery]');
  const thumbs     = document.querySelector('[data-gallery-thumbs]');
  const track      = document.querySelector('[data-gallery-track]');
  const zoomBtn    = document.querySelector('[data-zoom-toggle]');
  const zoomModal  = document.querySelector('[data-zoom-modal]');
  if (!gallery || !track) return;

  function getVisibleSlides() {
    return [...track.querySelectorAll('.product-gallery__slide:not(.is-hidden)')];
  }
  function getVisibleThumbs() {
    return thumbs ? [...thumbs.querySelectorAll('[data-thumb]:not(.is-hidden)')] : [];
  }

  let currentIndex = 0;

  function goToSlide(index) {
    const visibleSlides = getVisibleSlides();
    const visibleThumbs = getVisibleThumbs();
    if (visibleSlides.length === 0) return;

    if (index < 0) index = visibleSlides.length - 1;
    if (index >= visibleSlides.length) index = 0;
    
    currentIndex = index;
    
    // Shift track
    track.style.transform = `translateX(-${currentIndex * 100}%)`;
    
    // Update active slide class
    const allSlides = [...track.querySelectorAll('.product-gallery__slide')];
    allSlides.forEach(slide => slide.classList.remove('is-active'));
    if (visibleSlides[currentIndex]) {
      visibleSlides[currentIndex].classList.add('is-active');
    }

    // Update active thumbnail class
    const allThumbs = thumbs ? [...thumbs.querySelectorAll('[data-thumb]')] : [];
    allThumbs.forEach(thumb => thumb.classList.remove('is-active'));
    if (visibleThumbs[currentIndex]) {
      visibleThumbs[currentIndex].classList.add('is-active');
    }

    // Scroll active thumbnail horizontally inside container only
    if (visibleThumbs[currentIndex] && thumbs) {
      const thumb = visibleThumbs[currentIndex];
      thumbs.scrollTo({
        left: thumb.offsetLeft - (thumbs.clientWidth / 2) + (thumb.clientWidth / 2),
        behavior: 'smooth'
      });
    }
  }

  // Thumb clicks delegated to data-gallery-thumbs wrapper
  if (thumbs) {
    thumbs.addEventListener('click', e => {
      const clickedThumb = e.target.closest('[data-thumb]');
      if (!clickedThumb || clickedThumb.classList.contains('is-hidden')) return;
      const visibleThumbs = getVisibleThumbs();
      const visibleIndex = visibleThumbs.indexOf(clickedThumb);
      if (visibleIndex !== -1) {
        goToSlide(visibleIndex);
      }
    });
  }

  // Swipe events
  let touchStartX = 0;
  let touchEndX = 0;
  
  gallery.addEventListener('touchstart', e => {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });
  
  gallery.addEventListener('touchend', e => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  }, { passive: true });

  function handleSwipe() {
    const swipeThreshold = 50;
    if (touchStartX - touchEndX > swipeThreshold) {
      goToSlide(currentIndex + 1);
    } else if (touchEndX - touchStartX > swipeThreshold) {
      goToSlide(currentIndex - 1);
    }
  }

  // Desktop mousemove hover pan zoom
  track.querySelectorAll('.product-gallery__main-image').forEach(container => {
    const img = container.querySelector('img');
    if (!img) return;
    container.addEventListener('mousemove', e => {
      if (window.innerWidth < 768) return;
      const rect = container.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = 'scale(2)';
    });
    container.addEventListener('mouseleave', () => {
      img.style.transform = '';
      img.style.transformOrigin = '';
    });
  });

  // Zoom Modal integration
  if (zoomModal) {
    if (zoomModal.parentNode !== document.body) {
      document.body.appendChild(zoomModal);
    }
    const zoomImg = zoomModal.querySelector('[data-zoom-image]');

    function openZoomModal(imgSrc) {
      if (!imgSrc || !zoomImg) return;
      const hiResSrc = imgSrc.replace(/&width=\d+/, '&width=1800').replace(/\?width=\d+/, '?width=1800');
      zoomImg.src = '';
      zoomImg.src = hiResSrc || imgSrc;
      zoomModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeZoomModal() {
      zoomModal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    window.openZoomModal = openZoomModal;
    window.closeZoomModal = closeZoomModal;

    // Main gallery click -> opens zoom modal (both desktop & mobile)
    gallery.addEventListener('click', e => {
      if (e.target.closest('[data-gallery-thumbs]')) return;
      
      const zoomToggle = e.target.closest('[data-zoom-toggle]');
      const mainImg = e.target.closest('.product-gallery__main-image') || e.target.closest('.product-gallery__slide');
      
      if (zoomToggle || mainImg || e.target.tagName === 'IMG') {
        e.preventDefault();
        e.stopPropagation();
        let imgEl = e.target.tagName === 'IMG' ? e.target : null;
        if (!imgEl && mainImg) imgEl = mainImg.querySelector('img');
        if (!imgEl) {
          const visibleSlides = getVisibleSlides();
          const activeSlide = visibleSlides[currentIndex] || visibleSlides[0];
          if (activeSlide) imgEl = activeSlide.querySelector('img');
        }
        if (imgEl) {
          const src = imgEl.currentSrc || imgEl.src || imgEl.getAttribute('src');
          if (src) openZoomModal(src);
        }
      }
    });

    if (zoomBtn) {
      zoomBtn.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        const visibleSlides = getVisibleSlides();
        const activeSlide = visibleSlides[currentIndex] || visibleSlides[0];
        const imgEl = activeSlide ? activeSlide.querySelector('img') : gallery.querySelector('img');
        if (imgEl) {
          const src = imgEl.currentSrc || imgEl.src || imgEl.getAttribute('src');
          if (src) openZoomModal(src);
        }
      });
    }

    zoomModal.addEventListener('click', e => {
      if (e.target.closest('[data-zoom-close]') || e.target.closest('[data-zoom-backdrop]') || e.target === zoomModal) {
        closeZoomModal();
      }
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && zoomModal.classList.contains('is-open')) {
        closeZoomModal();
      }
    });
  }
}

/* ---- Delivery checker ---- */
function initDeliveryChecker() {
  const form    = document.querySelector('[data-delivery-check-form]');
  const input   = document.querySelector('[data-pincode-input]');
  const result  = document.querySelector('[data-delivery-result]');
  if (!form || !input || !result) return;
  form.addEventListener('submit', e => {
    e.preventDefault();
    const pin = input.value.trim();
    if (pin.length !== 6 || isNaN(pin)) {
      result.textContent = 'Please enter a valid 6-digit pincode.';
      result.className = 'delivery-result delivery-result--error';
      return;
    }
    /* Simulate delivery check */
    result.textContent = 'Checking...';
    setTimeout(() => {
      result.textContent = `Delivery available to ${pin} — Estimated 3–7 working days`;
      result.className = 'delivery-result delivery-result--success';
    }, 800);
  });
}

/* ---- Sticky add to cart ---- */
function initStickyBar() {
  const bar       = document.querySelector('[data-sticky-atc]');
  const sentinel  = document.querySelector('[data-sticky-sentinel]');
  const hideTrigger = document.querySelector('.related-products, #ProductReviews, .product-reviews-section, footer, .site-footer');
  if (!bar || !sentinel) return;

  let isSentinelPassed = false;
  let isHideTriggerVisible = false;

  function updateVisibility() {
    if (isSentinelPassed && !isHideTriggerVisible) {
      bar.classList.add('is-visible');
    } else {
      bar.classList.remove('is-visible');
    }
  }

  const sentinelObs = new IntersectionObserver(entries => {
    isSentinelPassed = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
    updateVisibility();
  }, { threshold: 0 });
  sentinelObs.observe(sentinel);

  if (hideTrigger) {
    const hideObs = new IntersectionObserver(entries => {
      isHideTriggerVisible = entries[0].isIntersecting;
      updateVisibility();
    }, { threshold: 0 });
    hideObs.observe(hideTrigger);
  }

  // Backup scroll fallback (highly reliable for mobile touch drag scrolling)
  window.addEventListener('scroll', () => {
    updateVisibility();
  }, { passive: true });
}

/* ---- Quantity selector ---- */
function initQtySelector() {
  document.querySelectorAll('[data-qty-selector]').forEach(sel => {
    const input = sel.querySelector('[data-qty-value]');
    sel.querySelector('[data-qty-dec]')?.addEventListener('click', () => {
      const v = Math.max(1, parseInt(input.value) - 1);
      input.value = v;
    });
    sel.querySelector('[data-qty-inc]')?.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
    });
  });
}

/* ---- Toast notification ---- */
window.showToast = function(message) {
  let toastContainer = document.querySelector('.toast-container');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.className = 'toast-container';
    document.body.appendChild(toastContainer);
  }
  
  const toast = document.createElement('div');
  toast.className = 'toast-notification';
  toast.textContent = message;
  
  toastContainer.appendChild(toast);
  
  setTimeout(() => {
    toast.classList.add('is-visible');
  }, 10);
  
  setTimeout(() => {
    toast.classList.remove('is-visible');
    setTimeout(() => {
      toast.remove();
    }, 300);
  }, 2200);
};

/* ---- Format money ---- */
function formatMoney(cents) {
  return '₹' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function initAll() {
  initGallery();
  initVariantPicker();
  initDeliveryChecker();
  initStickyBar();
  initQtySelector();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
